var map = {
	"./Chess_bdt60.png": 27,
	"./Chess_blt60.png": 28,
	"./Chess_kdt60.png": 29,
	"./Chess_klt60.png": 30,
	"./Chess_ndt60.png": 31,
	"./Chess_nlt60.png": 32,
	"./Chess_pdt60.png": 33,
	"./Chess_plt60.png": 34,
	"./Chess_qdt60.png": 35,
	"./Chess_qlt60.png": 36,
	"./Chess_rdt60.png": 37,
	"./Chess_rlt60.png": 38
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26;